var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "changepassword__wrapper" },
    [
      _c(
        "confirmationDialog",
        {
          attrs: {
            dialogStatus: _vm.dialogStatus,
            title: "Change Password",
            eventName: "changePasswordEvent",
            actions: _vm.actionsList
          },
          on: { changePasswordEvent: _vm.changePasswordActions }
        },
        [
          _c(
            "v-container",
            { staticClass: "pa-0" },
            [
              _c(
                "v-layout",
                { staticClass: "customized-textfield", attrs: { wrap: "" } },
                [
                  _vm.fromheader
                    ? _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("label", [_vm._v("Old Password*")]),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              placeholder: "Old Password",
                              solo: "",
                              flat: "",
                              type: "password",
                              "background-color": "#F7F7F7",
                              color: "#E34E25",
                              rules: [_vm.rules.required],
                              "append-icon": _vm.oldPassword ? "clear" : "",
                              "error-messages": _vm.invalidOldPassword
                                ? "Incorrect old password"
                                : ""
                            },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                              "click:append": function($event) {
                                _vm.oldPassword = ""
                              }
                            },
                            model: {
                              value: _vm.oldPassword,
                              callback: function($$v) {
                                _vm.oldPassword = $$v
                              },
                              expression: "oldPassword"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("label", [_vm._v("New Password*")]),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "New Password",
                          solo: "",
                          flat: "",
                          type: "password",
                          "background-color": "#F7F7F7",
                          color: "#E34E25",
                          "append-icon": _vm.newPassword ? "clear" : "",
                          rules: _vm.fromheader
                            ? [
                                _vm.rules.required,
                                _vm.rules.min,
                                _vm.rules.strongPassword
                              ]
                            : [_vm.rules.required]
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                          },
                          "click:append": function($event) {
                            _vm.newPassword = ""
                          }
                        },
                        model: {
                          value: _vm.newPassword,
                          callback: function($$v) {
                            _vm.newPassword = $$v
                          },
                          expression: "newPassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("label", [_vm._v("Confirm New Password*")]),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Confirm New Password",
                          solo: "",
                          flat: "",
                          type: "password",
                          "background-color": "#F7F7F7",
                          color: "#E34E25",
                          label: "Confirm New Password*",
                          "append-icon": _vm.cNewPassword ? "clear" : "",
                          rules: _vm.fromheader
                            ? [
                                _vm.rules.required,
                                _vm.rules.min,
                                _vm.rules.np_cnp_match
                              ]
                            : [_vm.rules.required, _vm.rules.np_cnp_match],
                          "error-messages": _vm.invalidCNewPassword
                            ? "The confirm Password and password you entered don't match"
                            : ""
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                          },
                          "click:append": function($event) {
                            _vm.cNewPassword = ""
                          }
                        },
                        model: {
                          value: _vm.cNewPassword,
                          callback: function($$v) {
                            _vm.cNewPassword = $$v
                          },
                          expression: "cNewPassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.invalidCNewPassword || _vm.invalidOldPassword,
                          expression:
                            "invalidCNewPassword || invalidOldPassword"
                        }
                      ],
                      staticClass: "error_message pa-2 ml-0"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.invalidOldPassword
                            ? "Invalid old password"
                            : "The confirm Password and password you entered don't match"
                        ) + " "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errorMessage,
                          expression: "errorMessage"
                        }
                      ],
                      staticClass: "error_message pa-2 ml-0"
                    },
                    [_vm._v(_vm._s(_vm.errorMessageDetails))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.successMessage,
                          expression: "successMessage"
                        }
                      ],
                      staticClass: "successMessage pa-2"
                    },
                    [_vm._v("Password changed successfully!")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }